export default __webpack_public_path__ + "static/media/Brk_Snr.972d828b.mp3";